import * as React from 'react';
import Container121 from '../components/container121';
import CustomDrawer from '../components/CustomDrawer';
import AvatarChat from '../components/AvatarStatic/AvatarChat';
import { Avatar, Typography, Stack, Grid2 as Grid, Card, Box, Button, IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Paper from '@mui/material/Paper';
import { styled, useTheme } from '@mui/material/styles';
import PeopleIcon from '@mui/icons-material/People';
import RelationsInfo from '../components/Contacts/RelationsInfo';
import Post from '../components/Contacts/Post';
import Profil from '../components/Contacts/Profil';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    height:'100%',
    // width: '100%', 
     // minHeight: '660px',
    borderRadius: '10px',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#5c5c5cc7',
    }),
  }));

export default function ContactsPage() {
    const [  drawerOpen, setDrawerOpen ] = React.useState(true);
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('md'));

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    }; 

    React.useEffect( () => {    
        if(!isSmall){
            setDrawerOpen(true)
        }else{
            setDrawerOpen(false)
        }
    }, [isSmall ] );




  return (
    <div style={{ position: 'relative', width: '100%', height: 'calc(100dvh - 65px)', display: 'flex', flexDirection: 'row' }}>
        <Stack direction='column' alignItems='center' >
            {/* <Stack direction="row" spacing={2} onClick={ () => handleDrawerToggle() } >
                <Button variant="outlined" startIcon={<PeopleIcon />}>
                    {drawerOpen? 'Znajomi':''}
                </Button>
            </Stack> */}
            {/* <ListItem disablePadding sx={{ display: 'block' }}>
                <ListItemButton 
                onClick={() => handleDrawerToggle() }>
                <ListItemIcon sx={{ color: 'white' }}><PeopleIcon /></ListItemIcon>
                <ListItemText primary='text' sx={{ color: 'white' }} />
                </ListItemButton>
            </ListItem> */}
            
            
            {!isSmall && <CustomDrawer open= {drawerOpen} setDrawerOpen={setDrawerOpen} isSmall={isSmall} side='right' />}
        </Stack>
        <Profil />
    
</div>
  );
}
